export const SET_IS_SCROLLED = 'SET_IS_SCROLLED'
